var map = {
	"./1.jpg": "YTMB",
	"./10.jpg": "7/wm",
	"./11.jpg": "hQn3",
	"./12.jpg": "u3WT",
	"./13.jpg": "Juz5",
	"./14.jpg": "WKXi",
	"./15.jpg": "Hi7N",
	"./16.jpg": "pEvt",
	"./17.jpg": "+FX6",
	"./2.jpg": "84Lw",
	"./3.jpg": "Wzr1",
	"./4.jpg": "VINc",
	"./5.jpg": "1neZ",
	"./6.jpg": "mbtb",
	"./7.jpg": "CUx3",
	"./8.jpg": "LrMQ",
	"./9.jpg": "GAy2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "C4HD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags ^\.\/.*\.jpg$
// module id = C4HD
// module chunks = 15